<form [formGroup]="otherAccesoryGroup" (ngSubmit)="updateAccesory()">
  <h1 mat-dialog-title>{{ 'titles.newAccessory' | translate }}</h1>
  <div mat-dialog-content>
    <div>
      <mat-form-field class="widthInput">
        <input
          matInput
          placeholder="{{ 'fieldNames.description' | translate }}"
          formControlName="accessoryDescription"
          autocomplete="off"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="widthInput">
        <input
          matInput
          placeholder="{{ 'fieldNames.cost' | translate }}"
          formControlName="cost"
          (keypress)="keyPressNumbersWithDecimal($event)"
          autocomplete="off"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>{{ 'quotation.titles.payType' | translate }}</mat-label>
        <mat-select style="width: 9em" formControlName="isFinanced">
          <mat-option value="SI">{{ 'fieldNames.financed' | translate }}</mat-option>
          <mat-option value="NO">{{ 'labels.cash' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <mat-checkbox formControlName="isInIncome">{{
        'quotation.titles.addRent' | translate
      }}</mat-checkbox>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ 'fieldNames.cancel' | translate }}</button>
    <button mat-button type="submit">{{ 'messages.accept' | translate }}</button>
  </div>
</form>
